<template>
    <div class="region-icon">
        <img v-if="icon" :src="icon" draggable="false" />
        <svg v-else viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#1a8vgwz62a)">
                <mask id="h5yx0znvlb" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="512" height="512">
                    <path
                        d="M104.626 0h302.748c14.123 0 27.825 2.767 40.726 8.224 12.46 5.27 23.648 12.813 33.256 22.42 9.607 9.608 17.151 20.797 22.42 33.256C509.233 76.8 512 90.503 512 104.626v302.748c0 14.123-2.767 27.825-8.224 40.726-5.269 12.46-12.813 23.648-22.42 33.256-9.608 9.607-20.796 17.151-33.256 22.42-12.901 5.457-26.603 8.224-40.726 8.224H104.626c-14.123 0-27.825-2.767-40.726-8.224-12.46-5.269-23.648-12.813-33.256-22.42-9.607-9.608-17.15-20.796-22.42-33.256C2.767 435.199 0 421.497 0 407.374V104.626C0 90.503 2.767 76.801 8.224 63.9c5.27-12.46 12.813-23.648 22.42-33.256 9.608-9.607 20.797-17.15 33.256-22.42C76.8 2.767 90.503 0 104.626 0z"
                        fill="#A0A0A0"
                    />
                </mask>
                <g mask="url(#h5yx0znvlb)">
                    <path fill="#3C3737" d="M0 0h512v512H0z" />
                </g>
            </g>
        </svg>
        <!-- <transition> -->
        <svg v-if="state" class="bullpinkle" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#h6nbi2mywc)">
                <path
                    d="M201.908 238.21c-11.766-.81-16.985 1.424-17.824 6.561-.015 3.097-1.971 7.336-5.376 8.283-4.044 1.112-8.332-2.278-9.346-5.947-.015-.048 0-.092-.015-.141-5.229.063-9.561.561-11.059.937-7.663 1.922-7.619 13.775-9.331 15.736-1.703 1.961-9.849 3.556-11.351 2.781-2.318-1.176-.054-7.947-.4-8.893-.347-.951-10.225 5.239-19.327 4.249-2.244-.244-8.61-.761-10.288-5.381-.917-2.488 2.688-6.619 6.449-6.644 3.761-.019 12.975-.17 14.966-2.907-.996-13.42-33.303-8.946-48.527-15.371-5.366-2.263-10.156-6.77-11.454-10.331-.912-2.493 1.77-5.878 5.824-5.464 1.352.132 11.883 3.439 15.64 2.342 3.726-8.62-24.362-25.576-29.215-32.542-4.849-6.966-7.566-14.429-2.751-17.302 4.814-2.873 19.292 18.034 27.42 13.405 3.433-1.956-8.113-17.454-7.323-38.142.312-7.854 2.434-16.58 6.322-17.351 2.156-.429 3.18 4.273 3.454 7.624.853 10.498 7.253 32.8 17.175 31.61 3.274-.395 2.956-20.663 3.039-23.38.088-2.717 1.376-10.976 4.225-10.161 2.38.673 3.224 2.117 3.761 9.268.98 13.097 8.434 43.415 22.351 44.41 3.702.263 6.137-24.088 6.312-26.571.171-2.478 3.122-10.059 6.522-8.473 3.4 1.585 3.742 6.414 3.873 8.79.361 6.024.781 32.112 11.625 50.356 6.614 11.151 36.98 11.717 36.98 11.717s7.244 17.586-2.351 16.927v.005zm108.185-.059c11.766-.809 16.986 1.425 17.825 6.561.014 3.098 1.97 7.337 5.375 8.283 4.044 1.112 8.332-2.278 9.347-5.946.014-.049 0-.093.014-.142 5.23.064 9.561.561 11.059.937 7.663 1.922 7.619 13.776 9.332 15.737 1.702 1.961 9.848 3.556 11.351 2.78 2.317-1.176.053-7.946.4-8.893.346-.951 10.224 5.239 19.327 4.249 2.244-.244 8.609-.761 10.287-5.38.917-2.488-2.687-6.62-6.448-6.644-3.761-.02-12.976-.171-14.966-2.908.995-13.419 33.302-8.946 48.527-15.37 5.365-2.264 10.156-6.771 11.453-10.332.912-2.493-1.77-5.878-5.824-5.463-1.351.131-11.883 3.439-15.639 2.341-3.727-8.619 24.361-25.576 29.214-32.541 4.849-6.966 7.566-14.43 2.752-17.303-4.815-2.873-19.293 18.034-27.42 13.405-3.434-1.956 8.112-17.454 7.322-38.141-.307-7.854-2.429-16.586-6.317-17.352-2.156-.429-3.18 4.274-3.454 7.625-.853 10.497-7.253 32.8-17.175 31.61-3.273-.396-2.956-20.664-3.039-23.381-.088-2.717-1.376-10.976-4.225-10.161-2.38.673-3.224 2.117-3.761 9.268-.98 13.098-8.434 43.415-22.351 44.41-3.702.264-6.136-24.088-6.312-26.571-.171-2.478-3.122-10.058-6.522-8.473-3.4 1.586-3.741 6.415-3.873 8.79-.361 6.025-.781 32.113-11.625 50.357-6.614 11.151-36.98 11.717-36.98 11.717s-7.244 17.585 2.351 16.926l-.005.005z"
                    fill="#CC9D5C"
                />
                <path
                    d="m127.043 248.195-.034.01c.893-.361 1.595-.81 2-1.366-.585-7.927-12.097-9.61-24.556-10.985 2.151.229 18.264 1.839 26.99-.918 9.361-2.956 18.996-11.024 27.869-12.868-3.361 1.756-7.605 3.756-11.917 7.888-4.313 4.132-7.21 13.698-20.347 18.239h-.005zm-17.326-31.483c-2.62.405-6.225-.434-8.542-1.595-3.878-1.937-2.507-5.385-6.117-8.932-3.605-3.546-19.249-7.21-32.566-19.244 7.132 7.654 31.483 23.01 27.995 31.074-.941.273-2.302.273-3.839.117 10.615 2.522 21.044-.191 23.064-1.415l.005-.005zm83.112 15.659s-10.688-.454-11.649 4.561c-1.059 5.541-1.22 9.287-6.273 10.673-5.049 1.385-5.717-5.293-5.717-5.293.073-.693.185-1.458.351-2.288-7.727 0-15.459 10.576-15.459 10.576h.005c1.069-1.268 2.425-2.249 4.2-2.698 1.161-.292 4.02-.653 7.678-.829.527-.024 1.074-.049 1.63-.063h.063c.551-.015 1.117-.03 1.693-.039.014.048 0 .092.014.141 1.01 3.668 5.298 7.059 9.347 5.946 3.405-.946 5.361-5.185 5.375-8.283.615-3.775 3.6-5.98 9.805-6.565l-1.068-5.835.005-.004zm171.785-2.474c-4.312-4.131-8.556-6.131-11.917-7.887 8.873 1.848 18.507 9.912 27.868 12.868 8.727 2.756 24.839 1.151 26.991.917-12.464 1.376-23.971 3.059-24.556 10.985.404.556 1.107 1 2 1.366-.01 0-.02-.005-.035-.01-13.136-4.541-16.034-14.107-20.346-18.239h-.005zm60.737-11.829c-1.537.156-2.898.161-3.839-.117-3.488-8.063 20.868-23.419 27.995-31.073-13.317 12.029-28.961 15.693-32.566 19.244-3.605 3.546-2.239 6.995-6.117 8.932-2.317 1.161-5.922 2-8.542 1.595 2.02 1.224 12.454 3.936 23.064 1.414l.005.005zm-107.239 20.078c6.205.586 9.19 2.79 9.805 6.566.014 3.098 1.97 7.337 5.375 8.283 4.044 1.112 8.332-2.278 9.347-5.946.014-.049 0-.093.014-.142.576.005 1.142.02 1.693.039h.063c.556.02 1.103.039 1.63.064 3.653.18 6.512.541 7.678.829 1.775.444 3.136 1.429 4.2 2.693h.004s-7.726-10.576-15.458-10.576c.171.829.283 1.595.351 2.288 0 0-.668 6.678-5.717 5.292-5.049-1.385-5.215-5.131-6.273-10.673-.961-5.014-11.649-4.561-11.649-4.561l-1.068 5.834.005.01z"
                    fill="#BF9357"
                />
                <path
                    d="M255.996 363.215c10.985-54.508 64.02-88.322 64.02-133.79 0-31.093-28.664-56.298-64.02-56.298-35.356 0-64.019 25.205-64.019 56.298 0 45.468 53.034 79.278 64.019 133.79z"
                    fill="#D92121"
                />
                <path
                    d="M255.996 173.122c35.356 0 49.385 25.205 49.385 56.298 0 45.468-38.4 79.278-49.385 133.79 10.985-54.507 64.02-88.322 64.02-133.79 0-31.093-28.664-56.298-64.02-56.298z"
                    fill="#CC1F1F"
                />
            </g>
        </svg>
        <!-- </transition> -->
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useState, stateProps } from '../composables/useState';

import ab from '../../images/region-icon/ab-region-icon.webp';
import bc from '../../images/region-icon/bc-region-icon.webp';
import sk from '../../images/region-icon/sk-region-icon.webp';
import mb from '../../images/region-icon/mb-region-icon.webp';
import on from '../../images/region-icon/on-region-icon.webp';
import qc from '../../images/region-icon/qc-region-icon.webp';
import ns from '../../images/region-icon/ns-region-icon.webp';
import nb from '../../images/region-icon/nb-region-icon.webp';
import nl from '../../images/region-icon/nl-region-icon.webp';
import yt from '../../images/region-icon/yt-region-icon.webp';

const props = defineProps({
    ...stateProps(),
    region: {
        type: String,
        default: null,
    },
});
const { state } = useState(props);

const region = computed(() => {
    return props.region;
});

const icon = computed(() => {
    switch (region.value) {
        case 'ab':
            return ab;
        case 'bc':
            return bc;
        case 'sk':
            return sk;
        case 'mb':
            return mb;
        case 'on':
            return on;
        case 'qc':
            return qc;
        case 'ns':
            return ns;
        case 'nl':
            return nl;
        case 'nb':
            return nb;
        case 'yt':
            return yt;
        default:
            return null;
    }
});
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

.region-icon {
    display: grid;
    max-width: Pathfinder.$icon-large;
    max-height: Pathfinder.$icon-large;

    > svg,
    img {
        grid-area: 1 / 1;
        width: 100%;
        height: 100%;
    }

    // .bullpinkle {

    //     animation: pin 0.7s cubic-bezier(0.25, 1, 0.5, 1);

    //     @keyframes pin {
    //         0% {
    //             transform: translateY(-30px) rotate(-30deg) scale(3);
    //             opacity: 0;
    //         }
    //         70% {
    //             transform: translateY(0) rotate(0deg);
    //             opacity: 1;
    //         }
    //         100% {
    //             transform: translateY(0) scale(1);
    //         }
    //     }

    //     &.v-enter-active {
    //         transition-property: transform, opacity;
    //     }

    //     &.v-enter-from {
    //         // transform: scale(2);
    //     }

    //     &.v-leave-active {
    //         transition-property: opacity, transform;
    //         transition-duration: 0.5s;
    //         transition-timing-function: ease;
    //     }

    //     &.v-leave-to {
    //         opacity: 0;
    //         transform: scale(0.5);
    //     }
    // }
}
</style>
